import React, { useState } from 'react'

import { EntityCardProps } from '../../../components/organisms/EntityCard'
import { FilterItem } from '../../../components/organisms/EntityFilter'
import { EntityList } from '../../../components/organisms/EntityList'
import {
  deleteProject,
  getProject,
  createProject
} from '../../../domain/usecases/Project'
import { getEntitiesCount } from '../../../domain/usecases/Reports'
import { useHistory } from 'react-router-dom'
import { useToasts } from 'react-toast-notifications'
import { filtersFactory } from '../../../main/factories/filters.factory'
import { convertProjectToEntity } from '../../../domain/converters/Project'
import { Button } from 'react-bootstrap'

import { DeleteModal } from '../../../components/molecules/DeleteModal'
import { usePermissions } from '../../../hooks/usePermissions'

type ListProjectsProps = {
  remoteGetProjects: getProject
  remoteGetEntitiesCount: getEntitiesCount
  remoteDeleteProject: deleteProject
  remoteCreateProject: createProject
}

const ListProjects = ({
  remoteGetProjects,
  remoteGetEntitiesCount,
  remoteDeleteProject,
  remoteCreateProject
}: ListProjectsProps) => {
  const history = useHistory()
  const { addToast } = useToasts()
  const { can } = usePermissions()
  const [loading, setLoading] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState('')

  const [projects, setProjects] = useState<EntityCardProps[]>([])
  const [selectedId, setSelectedId] = useState('')

  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  const [filters, setFilters] = useState<FilterItem[]>([])

  React.useEffect(() => {
    if (errorMessage) {
      addToast(errorMessage, {
        appearance: 'error',
        autoDismiss: true
      })
    }
  }, [errorMessage])

  const requestProjects = async () => {
    setLoading(true)
    try {
      const ProjectsResponse = await remoteGetProjects.getProjects()
      setProjects(
        convertProjectToEntity(
          ProjectsResponse,
          can.delete('projects') ? deleteProjectFunction : undefined,
          can.read('projects') ? RedirectToProjectDetails : undefined,
          undefined // Photo upload removed
        )
      )
      setLoading(false)
    } catch (error) {
      setErrorMessage('Não foi possível carregar os Empreendimentos.')
    }
  }

  React.useEffect(() => {
    requestProjects()
    remoteGetEntitiesCount
      .getEntitiesCount()
      .then((entitiesCount) =>
        setFilters(filtersFactory(entitiesCount, history))
      )
  }, [])

  const handleDelete = () => {
    try {
      remoteDeleteProject
        .deleteById({ id: selectedId })
        .then((res) => {
          requestProjects()
          handleClose()
        })
        .catch((error) => {
          handleClose()
          // mensagem do backend (ex.: empreendimento com unidades); toast direto
          // porque o errorMessage não repete o aviso quando o texto é o mesmo
          addToast(
            error?.message || 'Não foi possível excluir o Empreendimento.',
            { appearance: 'error', autoDismiss: true }
          )
        })
    } catch (err) {
      setErrorMessage('Não foi possível excluir o Empreendimento.')
      return err
    }
  }

  const deleteProjectFunction = (idProject: string) => {
    handleShow()
    setSelectedId(idProject)
  }

  const RedirectToProjectDetails = (id: string) => {
    history.push(`/projects/${id}`, { id: id })
  }

  return (
    <>
      <DeleteModal
        show={show}
        handleClose={handleClose}
        handleOk={handleDelete}
      />
      <EntityList
        activeFilter={2}
        title="Empreendimentos"
        filters={filters}
        buttons={
          can.create('projects') ? (
            <Button
              onClick={() => history.push('/projects/create')}
              variant="primary"
            >
              Adicionar Empreendimento
            </Button>
          ) : null
        }
        entityCards={projects}
      />
    </>
  )
}

export default ListProjects
